module.exports = __webpack_public_path__ + "img/8.64276b7d.jpg";